<template>
    <el-select v-model="val" :placeholder="$strings('word/select_sp')"
               :class="hclass" size="small" :disabled="disable" clearable filterable>
        <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
    </el-select>
</template>

<script>
import {SpSiteSpRead} from "../../api/spsite/api";

export default {
    name: "filter-sp",
    props: ['hclass', 'value', 'close-edit'],
    data() {
        return {
            disable: true,
            options: [],
            val: '',
        }
    },
    created() {
        this.fetchData();
    },
    watch: {
        val: function (v) {
            this.$emit('input', v);
        },
        value: function (v) {
            this.val = v;
        }
    },
    methods: {
        fetchData() {
            SpSiteSpRead({page: 1, size: 1000}).then((resp) => {
                this.options = [];
                resp.data.data.rows.forEach((item) => {
                    this.options.push({value: item.sp_id, label: item.sp_name});
                    this.disable = false;
                })
                this.$emit('load', resp.data.data.rows);
            });
        }
    }
}
</script>

<style scoped>

</style>